import { detectBlockerLazy } from 'owa-block-detector';
import { updateAdExp2UserOptionLazy } from 'owa-ads-experiment';
import { logUsage } from 'owa-analytics';
import { isFeatureEnabled } from 'owa-feature-flags';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import {
    embargoedMarkets,
    getAdMarketPublishGroupCode,
    IsChildConsumerUser,
    IsPremiumConsumerUser,
    IsShadowMailboxUser,
    supportedMarkets,
} from './sharedAdsUtils';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';

var showDisplayAds: boolean;
export function areDisplayAdsEnabled(): boolean {
    // caching this value as it doesn't change per session
    if (typeof showDisplayAds != 'undefined') {
        return showDisplayAds;
    }

    if (!isConsumer() || !isFeatureEnabled('fwk-ads')) {
        showDisplayAds = false;
    } else {
        let adsNotEnabledString = null;
        let adMarket = getAdMarketPublishGroupCode();

        let userConsumerAdsExpMode = getUserConfiguration().UserOptions.ConsumerAdsExperimentMode;

        // Make sure they have the AdsExperiments bit set and Display on is not set, then don't show ads
        if (IsPremiumConsumerUser() || IsShadowMailboxUser()) {
            adsNotEnabledString = 'AdPaidUser';
        } else if (embargoedMarkets.includes(adMarket)) {
            adsNotEnabledString = 'EmbargoedMarket';
        } else if (
            isFeatureEnabled('fwk-ads-disableDefaultPG') &&
            !supportedMarkets.includes(adMarket)
        ) {
            adsNotEnabledString = 'NonSupportedMarket';
        } else if (IsChildConsumerUser()) {
            adsNotEnabledString = 'ChildAccount';
        } else if (
            !isFeatureEnabled('fwk-ads-exp2-RuntimeBypass') &&
            (userConsumerAdsExpMode == 'DisplayOffNativeOff' ||
                userConsumerAdsExpMode == 'DisplayOffNativeOther' ||
                userConsumerAdsExpMode == 'DisplayOffNativeInbox')
        ) {
            adsNotEnabledString = 'AdsExp2';
        }

        showDisplayAds = adsNotEnabledString == null;
        if (showDisplayAds) {
            logUsage('AdsbarEnabled', {
                market: adMarket,
            });
        } else {
            logUsage('AdsbarNotEnabled', {
                owa_1: adsNotEnabledString,
                market: adMarket,
            });
        }

        if (isFeatureEnabled('fwk-ads-detectAdBlocker')) {
            detectBlockerLazy.importAndExecute();
        }

        updateAdExp2UserOptionLazy.importAndExecute();
    }

    return showDisplayAds;
}

export function setShowAds(value: any) {
    showDisplayAds = value;
}
